import React from 'react';
import PropTypes from 'prop-types';
import {Image} from '@learningblocks/shared-components';
import '../style.scss';

import TrashCan from '@common/images/mini-trash-icon.svg';

const ENTER_KEY = 13;
/**
 * RemoveOption :
 * - RemoveOption for HexagonCard
 */
export function RemoveOption(props) {
  const onClick = (event) => props.onSelect(event);

  const onKeyDown = (event) =>
    event.keyCode === ENTER_KEY && props.onSelect(event);

  return props.onSelect ? (
    <div
      tabIndex={props.tabIndex}
      onKeyDown={onKeyDown}
      onClick={onClick}
      className='hex_action'>
      <Image src={TrashCan} alt='remove node' />
    </div>
  ) : null;
}

RemoveOption.propTypes = {
  /**
   * Callback for onClick/onKeyDown event
   */
  onSelect: PropTypes.func,
  /**
   * tabIndex
   */
  tabIndex: PropTypes.number,
};

RemoveOption.defaultProps = {
  onSelect: undefined,
};
